/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import subHeading from '../../../../components/Web/CreditCheck/redesign/Components/subHeading';
import * as Actions from '../../actions';

const mapStateToProps = (state) => {
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo;

  return {
    creditReviewSuccessResponse,
  };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...Actions }, dispatch);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(subHeading));
